import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                a: '#b11116',
                primary: '#b11116',
                secondary: '#6a6a6a',
                accent: '#C1CE00',
                error: '#ff0033',
            },
            dark: {
                a: '#000000',
                primary: '#b11116',
                secondary: '#00A2A2',
                accent: '#C1CE00',
                error: '#ff0033',
            },
        },

    },
});
